import type { CadenceStep, ReminderChannel } from '@/types/reminder-policy';

export type OffsetUnit = 'm' | 'h' | 'd';

export interface CadenceFormStep {
  id: string;
  offsetValue: number;
  offsetUnit: OffsetUnit;
  channel: ReminderChannel;
  templateKey?: string;
}

export const UNIT_OPTIONS: Array<{ value: OffsetUnit; label: string }> = [
  { value: 'm', label: 'minutes' },
  { value: 'h', label: 'hours' },
  { value: 'd', label: 'days' },
];

const UNIT_TO_MINUTES: Record<OffsetUnit, number> = { m: 1, h: 60, d: 24 * 60 };

let stepIdCounter = 0;

function newStepId(): string {
  stepIdCounter += 1;
  return `step-${Date.now()}-${stepIdCounter}`;
}

export function makeEmptyCadenceStep(): CadenceFormStep {
  return makeCadenceStepForChannel('SMS');
}

export function makeCadenceStepForChannel(channel: ReminderChannel): CadenceFormStep {
  return {
    id: newStepId(),
    offsetValue: 0,
    offsetUnit: 'h',
    channel,
    templateKey: '',
  };
}

export function duplicateCadenceStep(step: CadenceFormStep): CadenceFormStep {
  return {
    ...step,
    id: newStepId(),
  };
}

export function offsetMinutesToFormValue(offsetMinutes: number): {
  offsetValue: number;
  offsetUnit: OffsetUnit;
} {
  const abs = Math.abs(offsetMinutes);
  const sign = offsetMinutes < 0 ? -1 : 1;
  if (abs % (24 * 60) === 0) {
    return { offsetValue: sign * (abs / (24 * 60)), offsetUnit: 'd' };
  }
  if (abs % 60 === 0) {
    return { offsetValue: sign * (abs / 60), offsetUnit: 'h' };
  }
  return { offsetValue: offsetMinutes, offsetUnit: 'm' };
}

export function formStepToCadence(step: CadenceFormStep): CadenceStep {
  return {
    offsetMinutes: Math.trunc(step.offsetValue * UNIT_TO_MINUTES[step.offsetUnit]),
    channel: step.channel,
    templateKey: step.templateKey?.trim() || undefined,
  };
}
